var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[(_vm.header || _vm.$slots.header)?_c('div',{staticClass:"card-header"},[(_vm.header)?_c('span',[_vm._v(_vm._s(_vm.header))]):_vm._t("header")],2):_vm._e(),_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }